<template>
  <div class="done">
    <div class="top">
      <img class="header-background" :src="require('@/assets/subscription/thnaks_for_subscribing_header.svg')">
    </div>
    <div class="message">
      <div class="text">הנה פרטי המנוי שלך:</div>
      <div class="name">{{ totalPaymentTitle }}</div>
      <div class="discounted-price" v-if="isPercentageDiscountBenefit">
        <span class="value">{{discountedPriceWithShach}}</span> {{ discountPricePerMonths }} </div>
      <div v-if="isPercentageDiscountBenefit" class="discounted-price">
        <span class="value">₪{{ subscriptionPrice }}</span> לאחר סיום ההטבה</div>
      <div v-else class="value">₪{{ subscriptionPrice }}</div>
      <div class="name">כרטיס אשראי לחיוב</div>
      <div class="value">{{ formattedCC }}</div>
      <div class="name">אימייל לשליחת הקבלות</div>
      <div class="value">
        <span>{{ activeMember.emailPiiValue }}</span>
        <button class="edit" @click="redirectToPersonalInfo"> ✏️<span class="link">עריכה</span></button>
      </div>
      <div class="name">תאריך ראשון לחיוב</div>
      <div class="value">{{ formattedFirstBillingDate }}</div>
      <riseup-button :title="backToCashflowButtonText" :action="backToCashflow" :size="'small'"/>
    </div>
    <div class="footer">
      <div class="text">המשימה שלנו היא להוביל שינוי בחברה הישראלית יחד עם הלקוחות שלנו,
        ולעזור לכל אחד ואחת לצמוח כלכלית.</div>
      <div class="bold">רוצה לקחת חלק?</div>
      <div>זה קורה <a href="https://bit.ly/30X5Ng4" target="_blank" class="link">בקבוצת הפייסבוק שלנו,</a> מחכים לך!</div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters, mapState } from 'vuex';
import BaseUI from 'base-ui';
import router from '@/router';
import AmbassadorsTouchPointPopup
  from '@/pages/responsive-pages/authenticated/navigation-pages/ambassadors/AmbassadorsTouchPointPopup';
import Segment from '../../../../../Segment';
import dates from '../../../../../utils/dates';
import WithFirstBillingDate from '../WithFirstBillingDate';

export default {
  name: 'Done',
  components: {
    RiseupButton: BaseUI.RiseupButton,
  },
  mixins: [WithFirstBillingDate],
  async created() {
    Segment.trackUserGot('SubscriptionDoneEntered', { subscriptionType: this.type });
    Segment.trackUserGotToPixel('SD');
  },
  computed: {
    ...mapGetters('subscription', ['cardLast4Digits', 'isYearlySubscription', 'subscriptionPrice']),
    ...mapState('subscription', ['type']),
    ...mapGetters('onboardingState', ['onboardingCompleted']),
    ...mapState('benefits', ['benefitType', 'benefitAmount', 'benefitPercentage']),
    ...mapGetters('benefits', ['BENEFIT_TYPES', 'discountedPrice', 'monthsText']),
    ...mapState('session', ['activeMember']),
    firstBillingDayInMonth() {
      return moment(this.firstBillingDate).date();
    },
    firstBillingMonth() {
      return dates.getHebrewMonth(this.firstBillingDate);
    },
    formattedFirstBillingDate() {
      return `${this.firstBillingDayInMonth} ל${this.firstBillingMonth}`;
    },
    formattedCC() {
      return `${this.cardLast4Digits} **** **** ****`;
    },
    isPercentageDiscountBenefit() {
      return this.benefitType === this.BENEFIT_TYPES.PERCENTAGE_DISCOUNT;
    },
    discountedPriceWithShach() {
      return `₪${this.discountedPrice}`;
    },
    discountPricePerMonths() {
      return ` ל-${this.monthsText}`;
    },
    totalPaymentTitle() {
      return this.isYearlySubscription ? 'סה״כ לתשלום שנתי' : 'סה"כ לתשלום בחודש';
    },
    backToCashflowButtonText() {
      return this.onboardingCompleted ? 'חזרה לתזרים שלך' : 'אפשר להמשיך';
    },
  },
  methods: {
    ...mapActions('modalRootStore', ['openModal']),
    ...mapActions('subscriptionState', ['initSubscriptionState']),
    async backToCashflow() {
      Segment.trackUserInteraction('SubscriptionDone_BackToCashflowClicked');
      if (this.onboardingCompleted) {
        this.openModal({
          component: AmbassadorsTouchPointPopup,
          props: {
            touchPointText: 'שמחים שבחרת להמשיך לצמוח איתנו!',
            query: { hideCta: true },
          },
        });
      } else {
        await this.initSubscriptionState();
        this.$router.push({ path: '/ob' });
      }
    },
    redirectToPersonalInfo() {
      router.push({ path: '/personal-info' });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~base-ui/src/scss/riseup-colors";
  @import '../../../../../scss/mixins';

  .done {
    position: relative;
    text-align: right;
    margin-bottom: 30px;

    .top {
      position: relative;
      text-align: center;
      margin-bottom: 30px;

      .header-background {
        width: 100%;
      }

      .title-container {
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 100%;
        align-items: center;
        color: $riseup_white;
        justify-content: center;

        .title {
          display: inline-block;
          @include title;
          line-height: 32px;
          white-space: pre-line;
        }
      }
    }

    .message {
      @include responsive-padding;

      .text {
        font-size: 20px;
        line-height: 1.2;
        margin-bottom: 18px;
      }

      .name {
        padding-top: 14px;
        font-size: 14px;
        line-height: 1;
        margin-bottom: 7px;
      }

      .discounted-price {
        font-size: 20px;
        line-height: 1.4;

        &:last-child {
          margin-bottom: 22px;
        }
      }

      .value {
        font-size: 20px;
        font-weight: bold;
        line-height: 1;
        margin-bottom: 22px;

        .edit {
          font-size: 16px;
          font-weight: normal;
          border: transparent;
          background: transparent;
          cursor: pointer;

          .link {
            text-decoration: underline;
            color: $riseup_blue;
          }
        }
      }

      .riseup-button {
        width: 100%;
        margin-top: 10px;
      }
    }

    .footer {
      margin-top: 50px;
      padding: 0px 40px 30px 40px;
      font-size: 16px;
      line-height: 1.38;

      .link {
        font-size: 16px;
        font-weight: bold;
        text-decoration: underline;
        color: $riseup_blue;
      }

      .bold {
        font-weight: bold;
        margin-top: 22px;
      }
    }
  }
</style>
